import * as types from './actionTypes';

export const fetchTax = (unit_id) => ({
  type: types.PAYROLL_DEDUCTION_FETCH_TAX,
  payload:{unit_id}
});

export const saveTax = (payload) => ({
  type: types.PAYROLL_DEDUCTION_SAVE_TAX,
  payload,
});

export const changeTaxStatus = (payload) => ({
  type: types.PAYROLL_DEDUCTION_CHANGE_TAX_STATUS,
  payload,
});
